var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":"table"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }